import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '@src/app/services/common.service';
import { TelegramService } from '@src/app/services/telegram.service';
import { UserService } from '@src/app/services/user.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { ChainEnum } from '@src/app/shared/types/wallet-chain.type';
import { bounceInOnEnterAnimation, tadaAnimation } from 'angular-animations';
import { MemeDashboardService } from '../../meme-dashboard.service';
import { WatchlistAgentInfo } from '../../meme-dashboard.type';

@Component({
    selector: 'app-watchlist-marketplace',
    templateUrl: './watchlist-marketplace.component.html',
    styleUrls: ['./watchlist-marketplace.component.less'],
    animations: [bounceInOnEnterAnimation(), tadaAnimation()],
})
export class WatchlistMarketplaceComponent implements OnInit, OnDestroy {
    ChainEnum = ChainEnum;
    subscribeFilterActive = false;
    sort: 'pnl_7d' | 'pnl_7d_bsc' | 'pnl_7d_base' | 'pnl_7d_sol' | 'subscriber_count' = 'pnl_7d';

    watchlistAgents: WatchlistAgentInfo[];

    pageInfo = { page: 1, size: 12 };
    isLastPage = false;

    bounceStatus = true;
    bounceInterval: any;

    get isWatchListAdded() {
        return this.walletStatusService.userProfile?.watchlist?.address_added;
    }

    get isAuthenticated() {
        return this.walletStatusService.isWalletConnected || this.tgService.isTGLogin;
    }

    get watchlistAgentImg() {
        return this.walletStatusService.userProfile?.watchlist?.logo_url;
    }

    constructor(
        public userService: UserService,
        private activateRoute: ActivatedRoute,
        private memeDashboardService: MemeDashboardService,
        private walletStatusService: WalletStatusService,
        private tgService: TelegramService,
        private router: Router,
        public commonService: CommonService
    ) {}

    ngOnInit() {
        this.handleParamsFromRoute();

        this.bounceInterval = setInterval(() => {
            this.bounceStatus = !this.bounceStatus;
        }, 3000);
    }

    ngOnDestroy() {
        clearInterval(this.bounceInterval);
    }

    filterChange() {
        this.watchlistAgents = [];
        this.pageInfo.page = 1;
        this.isLastPage = false;
    }

    fetchData() {
        const params = {
            ...(this.subscribeFilterActive && { subscribed: true }),
            ...(this.sort && { sort: this.sort }),
            ...this.pageInfo,
        };

        this.memeDashboardService.getMarketplaceWatchlist(params).subscribe({
            next: data => {
                this.watchlistAgents = this.watchlistAgents ? [...this.watchlistAgents, ...data.data] : data.data;
                this.isLastPage = data.total <= this.watchlistAgents.length;
                this.pageInfo.page++;

                if (!this.isLastPage) {
                    setTimeout(() => {
                        const skeleton = document.querySelector('nz-skeleton');
                        if (skeleton) {
                            const rect = skeleton.getBoundingClientRect();
                            const isVisible = rect.top <= window.innerHeight;
                            if (isVisible) {
                                this.fetchData();
                            }
                        }
                    }, 100);
                }
            },
            error: err => this.commonService.errorMessageByResponse(err),
        });
    }

    handleParamsFromRoute() {
        const needActiveSubscribedFilter = this.activateRoute.snapshot.queryParamMap.has('filter_subscribed');
        const needActiveSort = this.activateRoute.snapshot.queryParamMap.has('sort');

        if (needActiveSubscribedFilter) {
            this.subscribeFilterActive = true;
        }

        if (needActiveSort) {
            this.sort = this.activateRoute.snapshot.queryParamMap.get('sort') as 'pnl_7d' | 'subscriber_count';
        }
    }

    sortChange(type: 'pnl_7d' | 'pnl_7d_bsc' | 'pnl_7d_base' | 'pnl_7d_sol' | 'subscriber_count') {
        this.sort = type;

        this.watchlistAgents = null;
        this.pageInfo.page = 1;
        this.isLastPage = false;
    }

    goMyWatchlist() {
        if (this.isAuthenticated) {
            this.router.navigate(['/meme-dashboard/my-watchlist']);
        } else {
            this.commonService.showLogInModal();
        }
    }
}
